import { render, staticRenderFns } from "./ShortageRepayment.vue?vue&type=template&id=ffe99008"
import script from "./ShortageRepayment.vue?vue&type=script&lang=js"
export * from "./ShortageRepayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports